<div class="tag-editor" (clickOutside)="editorExit($event)">
  <h3 class="tag-editor-title" translate>CONTACTS_LIST.TAGS</h3>

  <mat-form-field class="example-chip-list tag-editor-list">
    <mat-chip-list #chipList aria-label="tag selection">
      <mat-chip
        *ngFor="let tag of chosenTagList"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(tag)">
        {{tag}}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input
        [placeholder]="'CONTACTS_LIST.TAG_PLACEHOLDER_SECONDARY' | translate"
        #tagInput
        [formControl]="tagCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let chosenTag of filteredTags | async" [value]="chosenTag">
        {{chosenTag}}
      </mat-option>
    </mat-autocomplete>
    <button class="tag-editor-button"
            [class.disabled]="!selectedContacts.length || !chosenTagList.length"
            (click)="setTagsForContacts()" translate>CONTACTS_LIST.SET_TAGS</button>
  </mat-form-field>
  <div class="tag-editor-error" *ngIf="tagSetError" translate>CONTACTS_LIST.SELECTION_NEEDED</div>
</div>
